export const SECTION_LABELS = {
  PROFILE: 'User Profile',
  REGION_ROUTE: 'Select Region and Route',
  ALERTS: 'Alerts',
  EMAIL_SUBSCRIPTION: 'Email Subscription',
  SAVE: 'Save',
  CANCEL: 'Cancel',
  USER_NAME: 'User Name',
  ON_LABEL: 'ON',
  OFF_LABEL: 'OFF',
};
